import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '@/lib/axios'
import { KpiWidget } from './KpiWidget'

export function KpiRdoConsegnaScadutaWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<number>({
    queryKey: ['dashboard', 'rdo-consegna-scaduta-count'],
    queryFn: async () => {
      const res = await axiosInstance.get('/purchase-requests/count', {
        params: { consegna_scaduta: true },
      })
      return res.data?.count ?? 0
    },
    staleTime: 30000,
  })
  return (
    <KpiWidget
      title="RDO consegna scaduta"
      value={data}
      loading={isLoading}
      color="#cf1322"
      onClick={() => navigate('/ordini?consegna_scaduta=true')}
    />
  )
}
